import { styled } from "styled-components";
const Calendar = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  color: theme.color.default,
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  outline: 0
}));
export {
  Calendar
};
